import {
  type SessionOutcomeKind,
  SESSION_OUTCOME_KINDS,
  VERDICT_CONFIDENCES,
} from '@sbc/domain-models/agents';

import { pick } from '@/lib/utils';

export type OutcomeConfidence = (typeof VERDICT_CONFIDENCES)[number];

export interface OutcomesListSearch {
  needsReview?: true;
  kind?: SessionOutcomeKind;
  confidence?: OutcomeConfidence;
  groupKey?: string;
  page?: number;
}

export function parseOutcomesListSearch(search: Record<string, unknown>): OutcomesListSearch {
  const page = typeof search.page === 'number' ? search.page : Number(search.page);
  return {
    needsReview: search.needsReview === true || search.needsReview === 'true' ? true : undefined,
    kind: pick(SESSION_OUTCOME_KINDS, search.kind),
    confidence: pick(VERDICT_CONFIDENCES, search.confidence),
    groupKey:
      typeof search.groupKey === 'string' && search.groupKey !== '' ? search.groupKey : undefined,
    page: Number.isInteger(page) && page > 1 ? page : undefined,
  };
}

export interface OutcomesTab {
  label: string;
  filter: { needsReview: true | undefined };
}

// The queue first, but unfiltered by default: the review rule is a hold, not a triage
// state, so a reader landing here should see everything the agents concluded.
export const OUTCOME_TABS: OutcomesTab[] = [
  { label: 'Review queue', filter: { needsReview: true } },
  { label: 'All outcomes', filter: { needsReview: undefined } },
];

export function isOutcomesTabActive(tab: OutcomesTab, search: OutcomesListSearch): boolean {
  return tab.filter.needsReview === search.needsReview;
}
